import { Box } from '@mui/material';
import pianoIcon from '../../assets/images/pianoIcon.png';
import soundIcon from '../../assets/images/soundIcon.png';
import { useDispatch, useSelector } from 'react-redux'
import { MainAppReducer } from 'Types';
import * as appActions from '../../Actions/app'
import { AuthReducer } from 'Types/AuthTypes';
import { CustomSwitch } from 'Components';

const Keyboard = () => {

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer)


  const {
    userData,
  } = data

  const dispatch = useDispatch()
  
  return (
    <Box sx={{height: 'calc(100vh - 200px)', overflow: 'scroll'}}>
    <Box sx={{
      marginLeft: '50px',
      width: '600px',
      backgroundColor: 'black',
      borderRadius: '5px',
      }}>
      <Box sx={{
        color: 'white',
        textAlign: 'left',
        marginLeft: '24px',
        marginRight: '24px',
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Box sx={{
          marginTop: '20px', 
          marginBottom: '20px',
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '26px',
          letterSpacing: '0.01em',
          color: '#FFFFFF',
          fontFamily: 'Lato'
          }}>
        Keyboard Settings
        </Box>
        {/* <Box sx={{marginBottom: '20px', display: 'flex', flexDirection: 'column'}}>
          <Box sx={{display:'flex', alignItems:'center', height: '25px'}}><img style={{height:"100%", marginRight: '10px'}} src={pianoIcon}/> Keyboard Range:</Box>
          <Box sx={{marginTop: '10px', marginLeft: '35px', display: 'flex'}}>
            <Box sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: '#ECECEC',
            }}>88 keys</Box>
            <Box sx={{
              marginLeft: '7px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: '#767C8C',
            }}>A0-C8</Box>
            <Box sx={{
              marginLeft: '7px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              textDecorationLine: 'underline',
              color: '#469F6A',
            }}>Edit</Box>
          </Box>
        </Box> */}
        <Box sx={{marginBottom: '20px', fontFamily: 'Lato'}}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '8px',
            marginTop: '5px',
          }}>
            <Box sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: userData?.audio_on ? '#767C8C' : '#ECECEC',
              transition: 'color 0.2s',
            }}>
              Keyboard Speakers
            </Box>
            <CustomSwitch
              checked={userData?.audio_on ?? true}
              onChange={(e) => {
                dispatch(appActions.setAudioOn({audioOn: e.target.checked}))
              }}
            />
            <Box sx={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '16px',
              letterSpacing: '0.01em',
              color: userData?.audio_on ? '#ECECEC' : '#767C8C',
              transition: 'color 0.2s',
            }}>
              Device Speakers
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
    </Box>
  )
}

export default Keyboard
